/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { ChatOverview, ChatOverview$inboundSchema } from "./chatoverview.js";

export type ListChatsResult = {
  /**
   * The list of chats
   */
  chats: Array<ChatOverview>;
  /**
   * Total number of chats (before pagination)
   */
  total: number;
};

/** @internal */
export const ListChatsResult$inboundSchema: z.ZodMiniType<
  ListChatsResult,
  unknown
> = z.object({
  chats: z.array(ChatOverview$inboundSchema),
  total: z.int(),
});

export function listChatsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListChatsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListChatsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListChatsResult' from JSON`,
  );
}
